import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useCssHandles } from '../../../../utils/functions';

type FilterNavigatorV3DrawerProps = {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
};
const list = ['Cor', 'Departamento', 'Marca', 'Tamanho', 'Faixa de preço'];
const CSS_HANDLES = [
	'sidebar',
	'accordionFilterContent',
	'sidebarWrapper',
	'filterApplyButtonWrapper',
	'accordionFilter',
	'filterBreadcrumbsContent',
	'filterAccordionBreadcrumbs',
	'accordionFilterItemTag',
	'caretIcon',
	'filterBreadcrumbsText',
	'filterButtonsBox',
	'filterAccordionItemBox',
	'filterClearButtonWrapper',
	'accordionFilterItem',
	'accordionFilterItemTitle',
	'accordionFilterItemIcon',
];
const Drawer = ({ isOpen, setIsOpen }: FilterNavigatorV3DrawerProps) => {
	const [display, setDisplay] = useState('dn');
	const [translateX, setTranslateX] = useState('0%');
	const { handles, withModifiers }: any = useCssHandles(`vtex-search-result-3-x`, CSS_HANDLES);

	useEffect(() => {
		isOpen ? setDisplay('') : setDisplay('dn');
		isOpen ? setTranslateX('0%') : setTranslateX('110%');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOpen]);

	return (
		<>
			<div
				className={`fixed dim bg-base--inverted top-0 z-9999 w-100 vh-100 o-40 left-0 ${display}`}
				style={{ willChange: 'opacity' }}
				onClick={() => setIsOpen(!isOpen)}
			></div>

			<div
				className={`${handles.sidebar} w-auto-ns h-100 fixed top-0 z-9999 bg-base shadow-2 flex flex-column w-80 right-0`}
				style={{
					transform: `translateX(${translateX})`,
					transition: 'transform 0.4s ease-in-out 0s',
				}}
			>
				<div className={`${handles.accordionFilter} h-100 pb9 overflow-scroll`}>
					<div
						className={`${handles.filterAccordionBreadcrumbs} pointer flex flex-row items-center pa5 bg-base w-100 z-max bb b--muted-4`}
					>
						<div role="button" className={`${handles.filterBreadcrumbsContent} pv4 flex items-center`}>
							<div className={`${handles.filterBreadcrumbsText} t-heading-4 c-on-base`}>Filtros</div>
						</div>
					</div>
					{list.map((item, index) => (
						<div
							className={`${handles.accordionFilterContainer} ${withModifiers('accordionFilterContainer', item)} pl7`}
						>
							<div
								role="button"
								className={`${handles.accordionFilterItem} ${withModifiers('filterAccordionItemBox', item)} t-body pr5 pv3 pointer bb b--muted-5 outline-0`}
							>
								<div className={`v${handles.accordionFilterContent} pv4 c-on-base t-heading-5`}>
									<span className={`${handles.accordionFilterItemTitle}`}>{item}</span>
									{index == 0 && (
										<div className={`${handles.accordionFilterItemTag} dib ml3`}>
											<div className="vtex-tag br-pill dib fw5 t-small pv2 ph4 bg-muted-2 c-on-muted-2 ">1</div>
										</div>
									)}
									<span className={`${handles.accordionFilterItemIcon} fr`}>
										<svg
											fill="none"
											width="10"
											height="10"
											viewBox="0 0 16 16"
											className={`${handles.caretIcon}`}
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
										>
											<use href="#nav-caret--down" xlinkHref="#nav-caret--down"></use>
										</svg>
									</span>
								</div>
							</div>
						</div>
					))}
				</div>
				<div
					className={`${handles.filterButtonsBox} bt b--muted-5 bottom-0 fixed w-100 items-center flex z-1 bg-base flex-wrap`}
				>
					<div className={`${handles.filterClearButtonWrapper} bottom-0 fl w-50 pl4 pr2`}>
						<button
							className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-regular t-action bg-transparent b--transparent c-action-primary hover-b--transparent hover-bg-action-secondary hover-b--action-secondary pointer w-100 "
							type="button"
						>
							<div
								className="vtex-button__label flex items-center justify-center h-100 ph6 w-100 border-box "
								style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
							>
								Limpar
							</div>
						</button>
					</div>
					<div className={`${handles.filterApplyButtonWrapper} bottom-0 fr w-50 pr4 pl2`}>
						<button
							className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-regular t-action bg-action-secondary b--action-secondary c-on-action-secondary hover-bg-action-secondary hover-b--action-secondary hover-c-on-action-secondary pointer w-100 "
							type="button"
						>
							<div
								className="vtex-button__label flex items-center justify-center h-100 ph6 w-100 border-box "
								style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
							>
								Aplicar
							</div>
						</button>
					</div>
				</div>
			</div>
		</>
	);
};
export default Drawer;
